import moment from 'moment';

const MAY = 4
moment.prototype._format = moment.prototype.format
moment.fn.format = function(pattern) {
  if (pattern.includes('MMM.') && this.month() === MAY) {
    pattern = pattern.replace('MMM.', 'MMM')
  }
  return this._format(pattern)
}
